// Named positions loadable by voice: "load the italian game",
// "set up a queen endgame". Matching picks the entry whose keywords
// hit the most words in the spoken phrase.

export const START_FEN = 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1';

export const OPENINGS = [
  {
    name: 'Starting position',
    keywords: ['start', 'starting', 'initial', 'beginning', 'normal'],
    fen: START_FEN,
  },
  {
    name: 'Italian Game',
    keywords: ['italian'],
    fen: 'r1bqkbnr/pppp1ppp/2n5/4p3/2B1P3/5N2/PPPP1PPP/RNBQK2R b KQkq - 3 3',
  },
  {
    name: 'Ruy Lopez',
    keywords: ['ruy', 'lopez', 'spanish'],
    fen: 'r1bqkbnr/pppp1ppp/2n5/1B2p3/4P3/5N2/PPPP1PPP/RNBQK2R b KQkq - 3 3',
  },
  {
    name: 'Sicilian Defense',
    keywords: ['sicilian'],
    fen: 'rnbqkbnr/pp1ppppp/8/2p5/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2',
  },
  {
    name: 'French Defense',
    keywords: ['french'],
    fen: 'rnbqkbnr/pppp1ppp/4p3/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2',
  },
  {
    name: 'Caro-Kann Defense',
    keywords: ['caro', 'kann', 'carokann'],
    fen: 'rnbqkbnr/pp1ppppp/2p5/8/4P3/8/PPPP1PPP/RNBQKBNR w KQkq - 0 2',
  },
  {
    name: "Queen's Gambit",
    keywords: ['gambit'],
    fen: 'rnbqkbnr/ppp1pppp/8/3p4/2PP4/8/PP2PPPP/RNBQKBNR b KQkq - 0 2',
  },
  {
    name: "King's Indian Defense",
    keywords: ['indian'],
    fen: 'rnbqkb1r/pppppp1p/5np1/8/2PP4/8/PP2PPPP/RNBQKBNR w KQkq - 0 3',
  },
  {
    name: 'London System',
    keywords: ['london'],
    fen: 'rnbqkb1r/pppppppp/5n2/8/3P1B2/8/PPP1PPPP/RN1QKBNR b KQkq - 2 2',
  },
  {
    name: "Scholar's Mate attack",
    keywords: ['scholar', 'scholars'],
    fen: 'r1bqkbnr/pppp1ppp/2n5/4p2Q/2B1P3/8/PPPP1PPP/RNB1K1NR b KQkq - 3 3',
  },
  {
    name: 'King and pawn endgame',
    keywords: ['pawn', 'king', 'endgame'],
    fen: '8/8/8/4k3/8/4P3/4K3/8 w - - 0 1',
  },
  {
    name: 'Queen endgame (mating practice)',
    keywords: ['queen', 'endgame'],
    fen: '4k3/8/8/8/8/8/8/4K2Q w - - 0 1',
  },
  {
    name: 'Rook endgame (mating practice)',
    keywords: ['rook', 'endgame'],
    fen: '4k3/8/8/8/8/8/8/R3K3 w - - 0 1',
  },
];

// Score every opening by keyword hits against the spoken words;
// return the best match or null.
export function findOpening(words) {
  let best = null;
  let bestScore = 0;
  for (const opening of OPENINGS) {
    const score = opening.keywords.reduce(
      (acc, kw) => acc + (words.includes(kw) ? 1 : 0),
      0
    );
    if (score > bestScore) {
      best = opening;
      bestScore = score;
    }
  }
  return best;
}
